var render = function (_h,_vm) {var _c=_vm._c;return _c('svg',{staticClass:"icon icon-checkmark",attrs:{"fill":"none","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }